import { useMount } from 'ahooks';
import { Dropdown } from 'antd';
import { useAppDispatch } from 'app/hooks';
import classNames from 'classnames';
import { ArrowDownIcon } from 'components/Icons';
import {
  GALLERY_TYPE_ENUM,
  SsoBuyerGalleryLabel,
} from 'domains/gallerySkuDomain';
import { JobConfigSourceEnum } from 'domains/jobconfigDomain';
import { usePage } from 'hooks';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import gallerySkuService from 'services/gallerySkuService';
import { startJobConfigWithGalleryLabel } from 'utils/gallery';
import { routesMap } from 'app/Router';
import './SsoBuyerShopDropdown.less';

interface Props {
  children?: React.ReactNode;
}

const SsoBuyerShopDropdown = ({ children }: Props) => {
  const [allLabels, setAllLabels] = useState<SsoBuyerGalleryLabel[]>([]);
  const { isShopPage } = usePage();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);

  useMount(async () => {
    try {
      const labels = await gallerySkuService.getSsoBuyerGalleryLabels();
      setAllLabels(labels || []);
    } catch (error) {
      console.error(error);
    }
  });

  const rootLabels = allLabels.filter((l) => !l.parentId);

  const handleLabelClick = (label: SsoBuyerGalleryLabel) => {
    setVisible(false);

    if (label.galleryType === GALLERY_TYPE_ENUM.COMPANY) {
      if (label.companyLabelId) {
        dispatch.companyGallery.setSelectedSkuType({
          id: label.companyLabelId,
          name: label.name,
        });
        history.push(routesMap.companyGallery.path);
      } else {
        // Navigate to Shop page with this category open
        history.push(`${routesMap.ssoBuyerShop.path}?parentId=${label.id}`);
      }
    } else {
      const children = allLabels.filter((l) => l.parentId === label.id);
      if (label.galleryLabelId || children.length > 0) {
        const dropDownLabels = children.map((l) => ({
          id: l.id,
          name: l.name,
          businessTypes: [],
          active: true,
          description: '',
          dropDownLabels: [],
          image: l.image,
          parentId: label.id,
          summary: '',
          version: 0,
          galleryLabels: [],
          galleryType: l.galleryType,
          companyLabelId: l.companyLabelId,
          galleryLabelId: l.galleryLabelId,
        }));

        const skuGalleryLabelCountMock = {
          skuCount: 0,
          skuLabel: {
            id: label.id,
            name: label.name,
            businessTypes: [],
            active: true,
            description: '',
            dropDownLabels: dropDownLabels,
            image: '',
            parentId: 0,
            summary: '',
            version: 0,
            galleryLabels: [],
            galleryType: label.galleryType,
            companyLabelId: label.companyLabelId,
            galleryLabelId: label.galleryLabelId,
          },
        };

        dispatch.jobConfig.setJobconfigSource(JobConfigSourceEnum.SHOP);
        startJobConfigWithGalleryLabel(
          dispatch,
          skuGalleryLabelCountMock,
          history
        );
      }
    }
  };

  const menu = (
    <div className="shop-filter">
      <div className="filter-block-title">Products</div>
      {rootLabels.map((label) => (
        <div
          key={label.id}
          className="filter-block-item"
          title={label.name}
          onClick={() => handleLabelClick(label)}
        >
          {label.name}
        </div>
      ))}
    </div>
  );

  return (
    <Dropdown
      placement="bottomCenter"
      visible={visible}
      onVisibleChange={setVisible}
      overlay={menu}
      overlayClassName="sso-buyer-shop-overlay"
    >
      {children ? (
        children
      ) : (
        <div
          className={classNames('shop', {
            active:
              isShopPage ||
              history.location.pathname === routesMap.ssoBuyerShop.path,
          })}
        >
          Shop <ArrowDownIcon />
        </div>
      )}
    </Dropdown>
  );
};

export default SsoBuyerShopDropdown;
